// Registration code configuration constants for secure-link and manual flows.
export const REGISTRATION_CODE_QUERY_PARAM = "reg_code";
export const REPORT_TOKEN_QUERY_PARAM = "report_token";
export const REGISTRATION_CODE_STORAGE_KEY = "registrationCode";
export const REGISTRATION_CODE_FIELD_LABEL = "registration code";
export const REGISTRATION_CODE_TOAST_ID = "registration-code-lock";
